import { useEffect, useState, useContext } from "react";
import $ from "jquery";
import { useNavigate } from "react-router-dom";
import { Card, ListGroup, Container, Row, Col } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import UserContext from "../../contexts/UserContext";

const RsvpCount = () => {
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(true);
    const [rsvpData, setRsvpData] = useState([]);
    const { user, setUser } = useContext(UserContext);

    async function getUser(userId) {
        try {
            const response = await $.ajax({
                type: "GET",
                url: process.env.REACT_APP_API_URL + "/getUsers/" + userId,
                xhrFields: { withCredentials: true },
                crossDomain: true
            });

            if (response && response.user) {
                setUser(response.user);
                if (!(response.user.role === 'admin' || response.user.role === 'fmbmember')) {
                    navigate("/home");
                }
            } else {
                setUser(null);
                navigate("/login", { state: { message: response.message } });
            }
        } catch (error) {
            console.log("Error getting user:", error);
            setLoading(false);
        }
    }

    async function getData() {
        try {
            const response = await $.ajax({
                type: "GET",
                url: process.env.REACT_APP_API_URL + "/rsvpCounts",
                xhrFields: { withCredentials: true },
                crossDomain: true
            });

            if (response.message && response.message.includes("Error in auth")) {
                navigate("/login", { state: { message: response.message } });
            } else {
                setRsvpData(Array.isArray(response) ? response : []);
            }
        } catch (error) {
            console.log("Error fetching RSVP counts:", error);
            setRsvpData([]);
        }
        setLoading(false);
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        
        const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

        if (date.toDateString() === today.toDateString()) {
            return "Today";
        } else if (date.toDateString() === tomorrow.toDateString()) {
            return "Tomorrow";
        } else {
            return `${weekDays[date.getDay()]}, ${date.toLocaleDateString()}`;
        }
    };

    useEffect(() => {
        if (user && (user.role === 'admin' || user.role === 'fmbmember')) {
            getData();
        } else {
            try {
                if (!user && localStorage.getItem('userSession')) {
                    getUser(JSON.parse(localStorage.getItem('userSession')));
                } else if (!user) {
                    navigate("/login");
                } else {
                    navigate("/home");
                }
            } catch (e) {
                if (!user) {
                    navigate("/login");
                }
            }
        }
    }, [user]);

    if (isLoading) {
        return (
            <div className="mx-auto mt-5 text-center" style={{width: "100px"}}>
                <Spinner style={{color:'brown'}} animation="border" role="status" />
                <br />
                <span>Loading counts...</span>
            </div>
        );
    }

    return (
        <Container fluid className="px-3">
            <Row className="justify-content-center">
                <Col xs={12} sm={10} md={8} lg={6} xl={5}>
                    <h6 className="m-3 text-center" style={{color: '#c38154'}}>
                        RSVP Count Summary
                    </h6>
                    
                    {rsvpData && rsvpData.length > 0 ? (
                        rsvpData.map((day, i) => (
                            <Card key={i} className="mb-4">
                                <Card.Header 
                                    style={{
                                        backgroundColor: '#c38154', 
                                        color: 'white',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    {formatDate(day.date)}
                                </Card.Header>
                                <ListGroup variant="flush">
                                    {day.rsvp.map((item, j) => {
                                        // Skip items that are "No Thaali" or have labels
                                        if (item.value === "No Thaali" || 
                                            (typeof item.name === 'object' && item.name.label)) {
                                            return (
                                                <ListGroup.Item key={j} className="text-muted">
                                                    {typeof item.name === 'string' ? item.name : `No Thaali - ${item.name.label}`}
                                                </ListGroup.Item>
                                            );
                                        }
                                        
                                        return (
                                            <ListGroup.Item key={j}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <strong style={{color: '#fff3cd'}}>
                                                            {item.name}
                                                        </strong>
                                                    </div>
                                                    <div>
                                                        <span className="badge" 
                                                              style={{
                                                                  backgroundColor: '#c38154',
                                                                  color: 'white',
                                                                  fontSize: '0.9em',
                                                                  padding: '0.5em 0.8em'
                                                              }}>
                                                            {item.value} Serving ({Math.round(item.value/2)} person)
                                                        </span>
                                                    </div>
                                                </div>
                                            </ListGroup.Item>
                                        );
                                    })}
                                </ListGroup>
                                
                                {/* Summary Section */}
                                <Card.Footer style={{backgroundColor: '#f8f9fa'}}>
                                    <small className="text-muted">
                                        Total items: {day.rsvp.filter(item => 
                                            item.value !== "No Thaali" && 
                                            !(typeof item.name === 'object' && item.name.label)
                                        ).length}
                                    </small>
                                </Card.Footer>
                            </Card>
                        ))
                    ) : (
                        <Alert variant='info'>
                            No menu data available for counting. Menus need to be created first!
                        </Alert>
                    )}
                </Col>
            </Row>
        </Container>
    );
};

export default RsvpCount;